import { IServiceBundle, IServicePreview } from 'app/interfaces/services';
import { IBranch } from 'app/interfaces/branches';
import { ISpecialistPreview } from 'app/interfaces/specialists';
import { IPost } from 'app/interfaces/posts';
import { IProductPreview } from 'app/interfaces/products';

export function getBranchUrl(item: Pick<IBranch, 'slug'>) {
  return `/branches/${item.slug}`;
}

export function getServiceUrl(
  item: Pick<IServicePreview, 'slug' | 'categories'>
) {
  const firstCategorySlug = item.categories?.[0]?.slug;
  return `/services/${firstCategorySlug}/${item.slug}`;
}

export function getServiceBundleUrl(item: Pick<IServiceBundle, 'slug'>) {
  return `/bundles/${item.slug}`;
}

export function getProductUrl(
  item: Pick<IProductPreview, 'slug' | 'categories'>
) {
  const firstCategorySlug = item.categories?.[0]?.slug;
  return `/store/${firstCategorySlug}/${item.slug}`;
}

export function getSpecialistUrl(
  item: Pick<ISpecialistPreview, 'slug' | 'category'>
) {
  const categorySlug = item.category?.slug;
  return `/specialists/${categorySlug}/${item.slug}`;
}

export function getPostUrl(item: Pick<IPost, 'slug' | 'category'>) {
  return `/media/${item.category.slug}/${item.slug}`;
}
